import { Component, OnInit } from '@angular/core';
import { MoveDirection, ClickMode, HoverMode, OutMode } from "tsparticles-engine";
import {HttpClient,HttpHeaders,HttpParams} from '@angular/common/http';
import { Report } from 'notiflix/build/notiflix-report-aio';
@Component({
  selector: 'app-career',
  templateUrl: './career.component.html',
  styleUrls: ['./career.component.scss']
})
export class CareerComponent implements OnInit {
  name:any;
  email:any;
  appliedfor:any;
  cv:File = null;
  phone:any;
  cvfile:File=null;
  constructor(private http : HttpClient) { }

  ngOnInit() {
  }

  onSubmit() {
    if(this.name==null  || this.name==""){
      Report.failure(
        'Name Missing',
        'Please fill Name in order to submit request !',
        'Okay',
        );
    }
    else if(this.email==null || this.email==""){
      Report.failure(
        'Email Missing',
        'Please fill Email in order to submit request !',
        'Okay',
        );
    }
    else if(this.phone==null || this.phone==""){
      Report.failure(
        'Phone Missing',
        'Please fill Phone in order to submit request !',
        'Okay',
        );
    }
    else if(this.appliedfor==null || this.appliedfor==""){
      Report.failure(
        'Applied For Missing',
        'Please fill Applied For in order to submit request !',
        'Okay',
        );
    }
    else if(this.cv==null ){
      Report.failure(
        'CV Missing',
        'Please upload CV in order to submit request !',
        'Okay',
        );
    }else{
      const myheader = new HttpHeaders();
      //myheader.set('Content-Type', 'multipart/form-data');

      let body = new FormData();
      body.append('Name', this.name);
      body.append('Phone', this.phone);
       body.append('Email', this.email);
      body.append('Applied For', this.appliedfor);
     
       body.append('Page', 'Career Page');
       body.append('cv', this.cvfile,this.cvfile.name); 

       let options = { headers: myheader };
        this.http.post("https://admin.osit.com.sa/api/contactus",body,options).subscribe((data) => {
        
          Report.success(
            'Request Sent',
            'Your request is successfully sent to concerned department, we will contact you soon !',
            'Okay',
            );
            this.name="";
            this.email="";
            this.appliedfor="";
            this.cv=null;
            this.phone="";
        });
     
    }
    
      }

      uploadFile(files: FileList) {  
     
          this.cvfile = files[0];
        
      }   

}
